import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Editor, Range } from 'slate';

/** Triple-click can set the selection focus point to
 *  the start of the following block node.
 *  Use this function to reset the selection focus point to the end of the previous block node
 *  */
export var normailizeSelection = function normailizeSelection(editor) {
  var selection = editor.selection;
  if (!selection) return false;
  var anchor = selection.anchor,
    focus = selection.focus;
  if (Range.isCollapsed(selection)) return;
  if (focus.offset !== 0) return;
  var _Editor$nodes = Editor.nodes(editor, {
      match: 'block',
      at: focus
    }),
    _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
    node = _Editor$nodes2[0];
  if (!node) return;
  if (Editor.isStart(editor, focus, node[1])) {
    var newFocusNode = Editor.before(editor, focus);
    var newSelection = {
      anchor: anchor,
      focus: newFocusNode
    };
    Editor.select(editor, newSelection);
  }
};